var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamondPurpleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#6A24FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9863 10.5L26.0137 10.5L30.5 18.2647L19.8595 31.5654L19.1405 31.5654L8.5 18.2647L12.9863 10.5ZM14.683 12.6569H14.2229L11.6922 17.0425H16.8686L14.683 12.6569ZM17.1275 12.6569L19.2987 17.0425H19.7013L21.8725 12.6569H17.1275ZM22.1314 17.0425L27.3078 17.0425L24.7771 12.6569H24.317L22.1314 17.0425ZM11.9797 19.1993L19.5 28.4595L27.0203 19.1993L11.9797 19.1993Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondPurpleIcon);
export default __webpack_public_path__ + "static/media/diamondPurpleIcon.491de83225803257e0a3b6ca68fef3fd.svg";
export { ForwardRef as ReactComponent };